/** @format */

import React from 'react';
import './styles.scss';
import { Dropdown, DropdownButton, ButtonGroup } from 'react-bootstrap';

export const LeadFormDropdown = ({
  wrapperClassName,
  dropdownClassName,
  onClick,
  valueList = [],
  dropdownTitle,
  selectedItems = [],
  selectedItemOnClick = null
}) => {
  return (
    <div className={`${wrapperClassName} leads-from-dropdown-wrapper`}>
      <DropdownButton
        as={ButtonGroup}
        title={dropdownTitle}
        className={dropdownClassName}>
        {valueList.map(({ label, value }, index) => (
          <Dropdown.Item key={index} onClick={() => onClick(value)}>
            {label}
          </Dropdown.Item>
        ))}
      </DropdownButton>

      <div className='selected-dropdown-items'>
        {selectedItems.map(({ key, label }, index) => (
          <span
            key={index}
            className='selected-item'
            onClick={
              selectedItemOnClick ? () => selectedItemOnClick(key) : null
            }>
            {label}
          </span>
        ))}
      </div>
    </div>
  );
};
